// extracted by mini-css-extract-plugin
export default {"mainPageBody":"MainPageBody_mainPageBody__6bQBE","sectionNavContainer":"MainPageBody_sectionNavContainer__v6TMa","sectionNavShowAll":"MainPageBody_sectionNavShowAll__1mbZe"};